jQuery('document').ready(function ($) {
    var cookieBox = {
        boxElem: $('.cookie'),
        boxActionAccept: $('.cookie .cookies_accept'),
        boxActionRefuse: $('.cookie .cookies_close')
    };
    var cookieObject = new CookiesPopup(cookieBox, 'megamark_cookies_accepted');
    cookieObject.setRefuseCookieCallback(function () {
        window['ga-disable-UA-123456789-1'] = true;
        console.log(window);
    });
    cookieObject.init();
});
